module.exports = __webpack_public_path__ + "img/p-one-step-02.41317348.png";